var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "458px",
    viewBox: "0 0 382 458",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blob") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blob",
    transform: "translate(0.833327, 0.446871)",
    fill: "#BB004B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.633346,126.958282 C355.033346,173.158282 380.333346,208.458282 380.333346,243.858282 C380.333346,279.258282 355.033346,314.558282 324.633346,352.858282 C294.333346,391.258282 259.033346,432.558282 207.133346,449.058282 C155.233346,465.558282 86.933346,457.258282 48.433346,418.858282 C9.93334601,380.558282 1.23334601,312.258282 0.133346008,242.658282 C-1.06665399,173.158282 5.23334601,102.458282 43.733346,56.2582821 C82.233346,10.0582821 152.933346,-11.5417179 205.933346,6.15828211 C259.033346,23.8582821 294.333346,80.8582821 324.633346,126.958282",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.29e0fc7296c5b49daae9848e53e8c7cc.svg";
export { ForwardRef as ReactComponent };